(function () {
    'use strict';

    angular
        .module('seatonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings.online', {
            abstract: true,
            parent: 'settings',
            url: '/online',
            data: {
                roles: ['ROLE_ADMIN', 'ROLE_OWNER', 'ROLE_MANAGER']
            },
            resolve: {
                googleChartApi: function (googleChartApiPromise) {
                    return googleChartApiPromise;
                }
            }
        });
    }
})();

